import Vue from 'vue';
import store from '../../store';
import equipmentTransformer from '../../transformers/equipment';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const equipments = equipmentTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedEquipments', { equipments, pagination });
  resolve(equipments);
};

const failed = (error, reject) => reject();

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('production/equipment', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/equipment/items.js